const ComingSoon = () => {
  return (
    <div className="min-h-screen bg-slate-100 dark:bg-gray-700 flex flex-col items-center justify-center">
      <h1 className="text-5xl text-slate-700 dark:text-white font-bold mb-8 animate-pulse">
        Coming Soon
      </h1>
      <p className="text-slate-900 dark:text-white text-lg mb-8"></p>
    </div>
  );
};

export default ComingSoon;
